import { Dayjs } from 'dayjs'
import { QUALINK_VIDEO_BASE_PATH } from '../global-config'
import { RoomMeetingResponse, UserResponse, RoomResponse } from '../openapi'

export const getRoomMeetingStatusText = (roomMeeting: RoomMeetingResponse) => {
  switch (roomMeeting.compositionStatus) {
    case 'completed':
      return 'ファイル作成済'
    case 'processing':
      return 'ファイル作成中'
    case 'not_started':
    default:
      return 'ファイル未作成'
  }
}

/**
 * ルーム名を取得する関数
 * shortNameが存在する場合はそちらを優先し、なければnameを返す
 * @param room ルーム情報
 * @returns 表示用のルーム名
 */
export const getRoomShortName = (room: RoomResponse): string => room.shortName || room.name || ''

/**
 * QuaLinkのビデオルームURLを生成する関数
 * @param me ユーザー情報
 * @returns ビデオルームURL
 */
export const createQuolinkVideoRoomUrl = (
  roomId: number,
  me: UserResponse,
  roomEndedAt?: Dayjs
): string => {
  const params = new URLSearchParams({
    roomId: roomId.toString(),
    name: me.nickname,
    userId: me.id.toString(),
    mike_status: me.cnfEnableMicAtStartOfMeeting?.toString() ?? "false",
    video_status: me.cnfEnableVideoAtStartOfMeeting?.toString() ?? "false", 
  });

  if (roomEndedAt) {
    params.set('endedAt', roomEndedAt.toISOString())
  }

  return `${
    QUALINK_VIDEO_BASE_PATH
  }/beforeRoom?${params.toString()}`;
};